module.exports = new __parcel__URL__("list-merge-modal-button-light.a31fc824.png").toString();